module.exports = __webpack_public_path__ + "img/icon-person-error.f14340b0.svg";